/**
 * i18n Configuration for Scout PWA
 */

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';
import {
  SUPPORTED_LANGUAGES,
  LANGUAGE_NAMES,
  LANGUAGE_CODES,
  LOCALE_MAP,
  applyDocumentDirection,
  isRTL,
  type SupportedLanguage,
} from '@tendedloop/shared/i18n';

// Re-export for convenience, other scout-pwa files import from '@/i18n'
export { SUPPORTED_LANGUAGES, LANGUAGE_NAMES, LANGUAGE_CODES, LOCALE_MAP, isRTL, type SupportedLanguage };

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: [...SUPPORTED_LANGUAGES],
    defaultNS: 'common',
    ns: ['common', 'scout', 'errors', 'globe'],
    detection: {
      order: ['querystring', 'localStorage', 'htmlTag'],
      caches: ['localStorage'],
      lookupQuerystring: 'lang',
      lookupLocalStorage: 'i18nextLng',
    },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json?v=20261010b',
    },
    saveMissing: import.meta.env.DEV,
    missingKeyHandler: import.meta.env.DEV
      ? (_lngs: readonly string[], ns: string, key: string) => {
          console.warn(`[i18n] Missing translation: ${ns}:${key}`);
        }
      : undefined,
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: true,
    },
    debug: import.meta.env.DEV,
  });

function loadEthiopicFont() {
  if (!document.getElementById('noto-sans-ethiopic')) {
    const link = document.createElement('link');
    link.id = 'noto-sans-ethiopic';
    link.rel = 'stylesheet';
    link.href = 'https://fonts.googleapis.com/css2?family=Noto+Sans+Ethiopic:wght@400;500;600;700&display=swap';
    document.head.appendChild(link);
  }
}

applyDocumentDirection(i18n.language);
if (i18n.language === 'am') loadEthiopicFont();

i18n.on('languageChanged', (lng) => {
  applyDocumentDirection(lng);
  if (lng === 'am') loadEthiopicFont();
});

export default i18n;
